import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import {
  AddToListChanged,
  AddToListFilterChanged,
  CloseActivateCustomerModal,
  CloseAddToListModal,
  CloseAdhocPoints,
  CloseCreateNewTicket,
  CreateTicketLM,
  FindCampaignsSuccess,
  GetCountriesSuccess,
  GetLoyaltyCardsSuccess,
  GetMemberPointSourcesSuccess,
  GetTicketCategoriesSuccess,
  InitActivateMemberColumns,
  InitConsentColumns,
  LoyaltyCardStatusChanged,
  PointsChanged,
  PointSourceChanged,
  RedeemAdHocPointsSuccess,
  RemarksChanged,
  TicketBodyChanged,
  TicketCategoryChanged,
  TicketCountryChanged,
  TicketSubjectChanged,
} from '../actions/lmembers-summary.actions';
import { MemberInfoActionsState } from '../models/member-summary.models';

const initialState: MemberInfoActionsState = {
  loyaltyCards: [],
  activateMemberDisplayedColumns: {},
  displayedColumns: {},
  categoryOptions: [],
  category: '',
  subject: '',
  countryOptions: [],
  country: '',
  body: '',
  tickerSubmit: false,
  points: '',
  remarks: '',
  pointSourceOptions: [],
  pointSource: 0,
  addToListOptions: [],
  addToList: '',
  addToListFilter: '',
};

// GetDetailedRFMAnalysisSuccess
// GetCouponsetSuccess
// GetSeveritiesSuccess
// GetStatusesSuccess
// GetAssignmentsSuccess
// GetCommunicationChannelsSuccess
// GetAvailableLanguagesSuccess
// GetCustomerSuccess
// FindCampaignsSuccess
// GetCSIChartsSuccess
// GetLifecycleChartsSuccess
// GetMemberSourcesSuccess
// GetLoyaltyCardSuccess
// GetCustomerReportingSuccess
// GetMemberScannedFormSuccess

export const MemberInfoActionsReducer = createReducer(
  initialState,
  on(InitConsentColumns, (state, { displayedColumns }) => ({
    ...state,
    displayedColumns,
  })),
  on(InitActivateMemberColumns, (state, { displayedColumns }) => ({
    ...state,
    activateMemberDisplayedColumns: displayedColumns,
  })),
  on(GetLoyaltyCardsSuccess, (state, { res }) => ({
    ...state,
    loyaltyCards: res.map((loyaltyCard) => ({
      ...loyaltyCard,
      selected: false,
    })),
  })),
  on(LoyaltyCardStatusChanged, (state, { card }) => ({
    ...state,
    loyaltyCards: state.loyaltyCards.map((loyaltyCard) =>
      loyaltyCard.loyaltyCardId === card.loyaltyCardId
        ? {
            ...loyaltyCard,
            selected: !loyaltyCard.selected,
          }
        : loyaltyCard,
    ),
  })),
  on(GetTicketCategoriesSuccess, (state, { res }) => ({
    ...state,
    categoryOptions: res,
  })),
  on(GetCountriesSuccess, (state, { res }) => ({
    ...state,
    countryOptions: res,
  })),
  on(GetMemberPointSourcesSuccess, (state, { res }) => ({
    ...state,
    pointSourceOptions: res,
  })),
  on(FindCampaignsSuccess, (state, { res }) => ({
    ...state,
    addToListOptions: res,
  })),
  on(AddToListFilterChanged, (state, { addToListFilter }) => ({
    ...state,
    addToListFilter,
    addToList: '',
  })),
  on(AddToListChanged, (state, { addToList }) => ({
    ...state,
    addToList,
    addToListFilter: addToList,
  })),
  on(CloseAddToListModal, (state) => ({
    ...state,
    addToList: '',
    addToListFilter: '',
  })),
  on(CloseActivateCustomerModal, (state) => ({
    ...state,
    loyaltyCards: [],
  })),
  on(TicketCategoryChanged, (state, { category }) => ({
    ...state,
    category,
  })),
  on(TicketCountryChanged, (state, { country }) => ({
    ...state,
    country,
  })),
  on(TicketSubjectChanged, (state, { subject }) => ({
    ...state,
    subject,
  })),
  on(TicketBodyChanged, (state, { body }) => ({
    ...state,
    body,
  })),
  on(CloseCreateNewTicket, (state) => ({
    ...state,
    category: '',
    subject: '',
    country: '',
    body: '',
    tickerSubmit: false,
  })),
  on(CreateTicketLM, (state) => ({
    ...state,
    tickerSubmit: true,
  })),
  on(PointsChanged, (state, { points }) => ({
    ...state,
    points,
  })),
  on(RemarksChanged, (state, { remarks }) => ({
    ...state,
    remarks,
  })),
  on(PointSourceChanged, (state, { pointSource }) => ({
    ...state,
    pointSource,
  })),
  on(CloseAdhocPoints, RedeemAdHocPointsSuccess, (state) => ({
    ...state,
    points: '',
    remarks: '',
    pointSource: 0,
  })),
  on(ActiveComponentChanged, (state, { activeComponent }) =>
    activeComponent === 'AllCustomersComponent' || activeComponent === 'MemberSearchComponent'
      ? {
          ...state,
        }
      : { ...initialState },
  ),
);
